import { COLORS, FONTS, TYPE, SPACING } from "../theme.js";

// Sapphire — bold modern header with a solid blue band behind the name.
// Section headings sit on a tinted background with a thin underline.
export const sapphireStyles = {
  meta: { label: "Sapphire (bold band)" },

  page: {
    paddingTop: 0,
    paddingBottom: 36,
    paddingLeft: 0,
    paddingRight: 0,
    backgroundColor: COLORS.white,
    fontFamily: FONTS.sans,
    fontSize: TYPE.body,
    color: COLORS.navy,
    lineHeight: 1.45,
  },

  header: {
    backgroundColor: COLORS.blueDeep,
    paddingTop: 28,
    paddingBottom: 22,
    paddingLeft: 40,
    paddingRight: 40,
    marginBottom: 18,
  },
  headerName: {
    fontSize: TYPE.name + 2,
    fontFamily: FONTS.sansBold,
    color: COLORS.white,
    letterSpacing: 0.4,
    marginBottom: 15,
  },
  headerHeadline: {
    fontSize: TYPE.headline,
    color: "#DBEAFE",
    fontFamily: FONTS.sansBold,
    marginTop: 2,
    letterSpacing: 0.4,
  },
  headerContact: {
    fontSize: TYPE.micro,
    color: "#BFDBFE",
    marginTop: 6,
  },
  sep: { color: "#93C5FD", marginHorizontal: 4 },

  section: {
    marginTop: 4,
    paddingLeft: 40,
    paddingRight: 40,
    marginBottom: SPACING.sectionGap,
  },
  sectionHeadingWrap: {
    marginBottom: 8,
    paddingBottom: 4,
    borderBottomWidth: 1,
    borderBottomColor: COLORS.blueBorder,
  },
  sectionHeading: {
    fontSize: TYPE.sectionHeading,
    fontFamily: FONTS.sansBold,
    textTransform: "uppercase",
    letterSpacing: 2,
    color: COLORS.blueDeep,
  },

  itemGroup: { marginBottom: SPACING.itemGap + 2 },
  itemGroupTight: { marginBottom: 4 },
  itemRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  itemTitle: {
    fontSize: TYPE.itemTitle,
    fontFamily: FONTS.sansBold,
    color: COLORS.navy,
  },
  itemTitleAlt: { color: COLORS.blue, fontFamily: FONTS.sansBold },
  itemTitleMuted: { fontFamily: FONTS.sans, color: COLORS.slate },
  itemSubtitle: {
    fontSize: TYPE.body,
    fontFamily: FONTS.sansItalic,
    color: COLORS.blue,
    marginTop: 1,
  },
  itemDate: {
    fontSize: TYPE.meta,
    color: COLORS.slate,
    fontFamily: FONTS.sans,
  },

  body: { fontSize: TYPE.body, color: COLORS.navy, marginTop: 2 },
  meta: { fontSize: TYPE.meta, color: COLORS.slate, marginTop: 2 },
  chipsLine: { fontSize: TYPE.body, marginTop: 3, color: COLORS.slate },
  labelStrong: { fontFamily: FONTS.sansBold, color: COLORS.blueDeep },
  italic: { fontFamily: FONTS.sansItalic },

  bullets: { marginTop: 4 },
  bulletRow: { flexDirection: "row", marginBottom: 3 },
  bulletMark: { width: 10, fontSize: TYPE.body, color: COLORS.blue },
  bulletText: { flex: 1, fontSize: TYPE.body, color: COLORS.navy },

  link: { color: COLORS.blue, textDecoration: "underline" },
  linkSmall: {
    color: COLORS.blue,
    textDecoration: "underline",
    fontSize: TYPE.meta,
  },
};
